import React, { useEffect, useState,useContext } from 'react';
import styles from "./loginSingup.module.css"
import {AiOutlineUser,AiOutlineKey, AiOutlineCheckCircle,AiOutlineLock} from 'react-icons/ai'
import {FiPhone} from 'react-icons/fi'
import axios from 'axios'
import { LoginSingupPageContext } from '../../context/loginSingupPageContext';
import  LogoSvg  from "../../assets/logo.js";
import Spinner from '../../components/loading/spinner';


const Singup = ()=>{
    const{setPageState}=useContext(LoginSingupPageContext);

    const[btn,setBtn]=useState({
        disabled:true
    })
    const [phone,setPhone]=useState("");
    const [countryInput,setCountryInput]=useState("");
    const [unameavail,setUnameAvail]=useState("--")
    const [username,setUsername]=useState("")




function checkUsername(e){

    setUsername(e.target.value)
    
    axios.post("https://vsam.me/api/api.php?request=usernameCheck",{
        "username":e.target.value
    }).then(res=>{
        if(res.data.status){
            setUnameAvail("yes")
        }else{
            setUnameAvail("no")
        }
    })
}




    function handlephonechange(e){
        setPhone(e.target.value)
        if(e.target.value.length>7){
            setBtn({
                disabled:false
            })
        }else{
            setBtn({
                disabled:true
            })
        }

    }




function getipDetail(){
    axios.get("https://freegeoip.app/json/").then(res=>{
       
       
        axios.get(`https://restcountries.eu/rest/v2/alpha/${res.data.country_code}`).then(data=>{
           setCountryInput(data.data.callingCodes[0])       
        })

    })

}

       


useEffect(()=>{
    getipDetail()
    return()=>{
  }
},[])

    return(
        <div className={styles.right}>
           <LogoSvg/>
            <h1 style={{textAlign:"center"}}>Create an account</h1>
            <form style={{width:"90%"}}>
                <div className={styles.input}>
                    <div className={styles.loginicon}><AiOutlineUser/></div>
                <input value={username} onChange={checkUsername} placeholder="username"/>
                <div className={styles.loginicon}> 
                {unameavail==="yes"?
                <AiOutlineCheckCircle color="green"/>
                :""}
                </div>
                </div>
               {unameavail==="no"?
                <div className={styles.takentxt}>This username is already taken</div>
                :""}
         <br/>

                <div className={styles.phoneInputContainer}>
                                    
                <input  value={countryInput} onChange={(e)=>setCountryInput(e.target.value)} placeholder="---" className={styles.inputcountry}></input>
                <input value={phone} onChange={handlephonechange} className={styles.phoneInput} type="tel" placeholder="Phone"/>
                </div>
                <div className={styles.takentxt}>This Phone number is already exists</div>
                <div className={styles.enterOtpContainer}>
                    <input maxLength={6} placeholder="OTP" type="text" />


                </div>
              
            <br/>
           
            {/* <div className={styles.input}>
                <div className={styles.loginicon}><AiOutlineLock  /></div>
            <input placeholder="Password" type="password"/>
            </div>
            <br/>
            <div className={styles.input}>
                <div className={styles.loginicon}><AiOutlineLock  /></div>
            <input placeholder="confirm password" type="password"/>
            </div> */}
            <button disabled={btn.disabled} className={styles.btn}>Verify OTP</button>
          

            </form>
            <br/>
            <div onClick={()=>setPageState("login")} className={styles.link} >Back to login</div>
           
        </div>
    )
}

export default Singup